/* src/app/components/order-list/order-list.component.scss */
:host {
  display: block;
  width: 100%;
}
:host:not(:last-child) {
  margin-bottom: 10px;
}
.discount-badges {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
}
.order-item {
  width: 100%;
  border-bottom: 1px solid #383838;
  padding: 20px 18px;
  background-color: #0d1117;
}
.order-item .img_section .img_wrap {
  width: 100%;
  height: 100%;
  background: #1c1c1c;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}
.order-item .img_section .img_wrap:has(.default-img) {
  padding: 18px;
  --icon-color: var(--color-black);
  object-fit: contain !important;
}
.order-item .img_section .article-img {
  object-fit: cover;
  width: 100%;
  height: 100%;
}
.order-item .img_section .default-img {
  object-fit: contain !important;
  width: 100%;
  height: 100%;
}
.order-item .name-row {
  margin-bottom: 8px;
}
.order-item .order-article-name {
  font-size: 18px;
  line-height: 120%;
  letter-spacing: 2%;
  vertical-align: middle;
  text-transform: uppercase;
  color: #fff;
}
.order-item .article-price {
  font-size: 18px;
  line-height: 120%;
  letter-spacing: 0.02em;
  vertical-align: middle;
  text-transform: uppercase;
  color: #fff;
}
.order-item .info-article-section .article-content {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0px 10px;
}
.icons_block {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.edit_section {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
}
.edit_section ion-icon {
  height: 30px;
  width: 30px;
  cursor: pointer;
}
.extras-row {
  margin-bottom: 10px;
}
.extras-list {
  width: 100%;
}
.extras-list .extra-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 0;
}
.extras-list .extra-item .extra-name {
  font-size: 12px;
  line-height: 120%;
  text-transform: uppercase;
  color: #ccc;
}
.extras-list .extra-item .extra-price {
  font-size: 12px;
  line-height: 120%;
  text-transform: uppercase;
  color: #ccc;
  margin-left: 10px;
}
.center-vertical {
  display: flex;
  align-items: center;
}
.quantity-selector {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1.5px solid #fff;
  border-radius: 50px;
  width: fit-content;
  background: #383838;
  padding: 8px 12px;
  gap: 10px;
  min-width: 80px;
}
.quantity-selector ion-icon {
  cursor: pointer;
  width: 12px;
  height: 12px;
  flex-shrink: 0;
  color: #fff;
}
.quantity-selector .quantity {
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  text-transform: capitalize;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  min-width: 16px;
}
.quantity-selector .quantity-btn-left {
  width: 12px;
  height: 12px;
}
.quantity-selector .quantity-btn-right {
  width: 12px;
  height: 12px;
}
.items-block {
  display: flex;
  align-items: center;
  justify-content: right;
}
.items-block .circle-quantity {
  width: 25px;
  height: 25px;
  border: 1px solid var(--color-black);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
}
.paddig-top {
  padding-top: 10px;
}
.flex-end {
  justify-content: flex-end;
}
.note {
  font-size: 12px;
  word-wrap: break-word;
  word-break: break-word;
  color: #999;
  margin-top: 8px;
  font-style: italic;
}
/*# sourceMappingURL=order-list.component.css.map */
